import { toProps } from '@graphistry/falcor';
import { Options } from '@graphistry/viz/src/containers/settings';
import { Selection } from '@graphistry/viz/src/containers/selection';
import { container } from '@graphistry/falcor-react-redux';
import { Renderer as RendererComponent } from '@graphistry/viz/src/components/renderer';

let Renderer = (
    {
        highlight = {},
        selection = {},
        background = {},
        axis = {},
        edges = {},
        points = {},
        camera = {},
        ...props
    } = {}
) => {
    return (
        <RendererComponent
            axis={toProps(axis)}
            edges={toProps(edges)}
            points={toProps(points)}
            camera={toProps(camera)}
            highlight={toProps(highlight)}
            selection={toProps(selection)}
            background={toProps(background)}
            {...props}
        />
    );
};

Renderer = container({
    renderLoading: true,
    fragment: ({ highlight = {}, selection = {}, layout: { settings } = {} } = {}) => `{
        showArrows,
        camera: {
            zoom,
            center: { auto, x, y, z }
        },
        edges: { scaling, opacity, elements, curvature },
        points: { scaling, opacity, elements, neighborhoodHighlight, neighborhoodHighlightHops, stroke },
        ['background', 'foreground']: { color },
        labels: { poiMax, propertiesEnabled, showActions, inspectorEnabled },
        highlight: { point, edge, darken },
        selection: ${Selection.fragment(selection)},
        layout: {
            settings: ${Options.fragments(settings)}
        }
    }`,
    mapFragment: (fragment, props, $falcor) => ({ $falcor, ...fragment, ...props })
})(Renderer);

export { Renderer };
